// extracted by mini-css-extract-plugin
export default {"msg":"v4GLm0"};